__turbopack_context__.v({
  "h2": "styleConstants-module__v0eWvq__h2",
  "h2Large": "styleConstants-module__v0eWvq__h2Large",
  "h3": "styleConstants-module__v0eWvq__h3",
  "p": "styleConstants-module__v0eWvq__p",
  "productSectionPadding": "styleConstants-module__v0eWvq__productSectionPadding",
  "sectionPadding": "styleConstants-module__v0eWvq__sectionPadding",
});
